import { render, staticRenderFns } from "./IlpaPhotos.vue?vue&type=template&id=5f8c1a05&scoped=true"
import script from "./IlpaPhotos.vue?vue&type=script&lang=js"
export * from "./IlpaPhotos.vue?vue&type=script&lang=js"
import style0 from "./IlpaPhotos.vue?vue&type=style&index=0&id=5f8c1a05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c1a05",
  null
  
)

export default component.exports